import React, { useCallback, useEffect, useState } from 'react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import getSteps from '../Scripts/_getSteps';
import Swal from 'sweetalert2';
import { useAppContext } from '../context/AppContext';
import axios from 'axios';

const VerticalStepper = () => {
  const {
    captureModeIsActive,
    editingEvalModeIsActive,
    currentAthleteSessionIndex,
    currentAthleteEvaluations,
    user,
    savingEvalMode,
    athlete,
    activeStep, 
    setActiveStep,
    createEvaluation,
    inputValuesObject,
    evalInputModeActive, 
  } = useAppContext();

  const [generateReportMode, setGenerateReportMode] = useState(false);

  const steps = getSteps(athlete?.program);

  const handleBack = useCallback(() => { 
    setActiveStep(prevStep => Math.max(0, prevStep - 1));
  }, [setActiveStep]);

  const handleReset = useCallback(() => {
    setActiveStep(0);
  }, [setActiveStep]);

  const handleStepClick = useCallback((index) => {
    setActiveStep(index);
  }, [setActiveStep]);

  const handleEvaluationSubmission = useCallback(async () => {
    if (captureModeIsActive) {
      {
        inputValuesObject['dataType'] = evalInputModeActive ? 'Eval' : 'Training';
        createEvaluation(inputValuesObject, athlete);
      }
    } else {
      const thisEvaluationInputDataObject = currentAthleteEvaluations[currentAthleteSessionIndex]; 
      
      setGenerateReportMode(true);
      try {
        const prevEvaluationInputDataObject = currentAthleteSessionIndex < (currentAthleteEvaluations.length - 1) 
          ? currentAthleteEvaluations[currentAthleteSessionIndex + 1] 
          : {};

        const response = await axios.post(`${process.env.REACT_APP_API_URL}api/flask`, {
          functionName: 'GenerateSessionReportPDF_ATH',
          inputArray: [thisEvaluationInputDataObject, prevEvaluationInputDataObject, user.username]
        });

        const getURLString = `${process.env.REACT_APP_API_URL}download?filePath=${encodeURIComponent(response.data)}`;
        const res = await axios.get(getURLString, { responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;

        const fileName = response.data.split('\\').pop().split('/').pop();
        link.setAttribute('download', fileName);
        link.click();
      } catch (error) {
        console.error('Error generating report:', error);
        Swal.fire('Error', 'Failed to generate report', 'error');
      } finally {
        setGenerateReportMode(false);
      }
    }
  }, [captureModeIsActive, createEvaluation, inputValuesObject, athlete, currentAthleteEvaluations, currentAthleteSessionIndex, user.username, evalInputModeActive]);

  const handleNext = useCallback(async () => {
    if (activeStep === steps.length - 1 && !editingEvalModeIsActive) {
      await handleEvaluationSubmission();
    } else {
      setActiveStep(prevStep => Math.min(steps.length - 1, prevStep + 1));
    }
  }, [activeStep, editingEvalModeIsActive, steps.length, handleEvaluationSubmission, setActiveStep]);

  useEffect(() => {
    if (generateReportMode) {
      Swal.fire({
        title: 'Generating Report',
        text: 'Please wait. This may take a few seconds.',
        footer: 'Your download will be ready soon',
        didOpen: () => { Swal.showLoading() },
        allowOutsideClick: false,
      });
    } else if (savingEvalMode) {
      Swal.fire({
        title: 'Storing evaluation',
        text: 'Please wait. This may take a few seconds.',
        footer: 'Your eval will be ready to analyze soon',
        didOpen: () => { Swal.showLoading() },
        allowOutsideClick: false,
      });
    } else if (Swal.isVisible()) {
      Swal.close();
    }
  }, [generateReportMode, savingEvalMode]);

  return (
    <div style={{minWidth: '15vw'}}>
      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map((label, index) => (
          <Step 
            style={{cursor:'pointer'}}
            key={label} 
            onClick={() => handleStepClick(index)}
            completed={false}
            disabled={false}
          >
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <div>
        {activeStep === steps.length ? (
          <div>
            <Typography>All steps completed</Typography>
            <Button onClick={handleReset}>Reset</Button>
          </div>
        ) : (
          <div>
            <div style={{justifyContent:'center'}}>
              <Button 
                disabled={activeStep === 0} 
                onClick={handleBack}
              >
                {'<<'}
              </Button>
              <Button
                variant="contained"
                color="inherit"
                onClick={handleNext}
              >
                {activeStep === steps.length - 1 
                  ? (captureModeIsActive 
                    ? 'Submit' 
                    : (editingEvalModeIsActive ? 'Editing' : 'Export'))
                  : '>>'}
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerticalStepper;